'use client';

import { createContext } from 'react';

import type { MenuItemContextInterface } from '../types/menu-item.types';

export const MenuItemContext = createContext<MenuItemContextInterface>({});

MenuItemContext.displayName = 'Menu.Item.Context';
